import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { GET_ALL_EVENTS } from "../../services/endpoints";
import axiosAPI from "../../services/axios";

export enum SortType {
  DATE_SOONEST = "date-soonest",
  DATE_FURTHEST = "date-furthest",
  ASCENDING = "titleAscending",
  DESCENDING = "titleDescending",
  MOST_SIGNUPS = "mostSignups",
  LEAST_SIGNUPS = "leastSignups",
}

export enum FormatType {
  ALL = "All",
  IN_PERSON = "In Person",
  HYBRID = "Hybrid",
  VIRTUAL = "Virtual"
}

export enum OfficeLocation {
  NEW_ENGLAND = "Boston & Hartford (New England)",
  BOSTON = "Boston",
  HEARTFORD = "Heartford"
}

export interface FilterType {
  office: OfficeLocation;
  format: FormatType;
  eventTags: string[];
}

export const getAllEvents = createAsyncThunk(
  "events",
  async (nil, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: GET_ALL_EVENTS(),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const filterAndSortEvents = createAsyncThunk(
  "events/sortAndFilter",
  async (params: { sortBy?: string; format?: string, filters: FilterType }, { rejectWithValue }) => {
    try {
      return params;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const clearSortAndFilterEvents = createAction(
  "events/sortAndFilter/clear"
);
